import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        redirect: '/stores'
    },
    {
        path: '/menu',
        name: 'main',
        component: () => import('@/pages/Main.vue'),
        meta: {
            breadcrumb: 'Онлайн меню'
        }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/pages/Dashboard.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Админ панель'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/Login.vue'),
        meta: {
            layout: 'Default'
        }
    },
    {
        path: '/oauth/success',
        name: 'oauth-success',
        component: () => import('@/pages/OAuthSuccess.vue'),
        meta: {
            layout: 'Default'
        }
    },
    {
        path: '/oauth/error',
        name: 'oauth-error',
        component: () => import('@/pages/OAuthError.vue'),
        meta: {
            layout: 'Default'
        }
    },
    {
        path: '/registration',
        name: 'registration',
        component: () => import('@/pages/Registration.vue'),
        meta: {
            layout: 'Default'
        }
    },
    // {
    //   path: '/profile',
    //   name: 'profile',
    //   component: () => import('@/pages/Profile.vue'),
    //   meta: {
    //     layout: 'Default',
    //     breadcrumb: 'Профиль'
    //   }
    // },
    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/pages/Settings.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Настройки'
        }
    },
    {
        path: '/brands',
        name: 'brands',
        component: () => import('@/pages/admin/Brands.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Бренды'
        }
    },
    {
        path: '/brand/claim/create',
        name: 'brand-claim-create',
        component: () => import('@/pages/admin/ClaimCreate.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Создать заявку',
            parent: {
                route: '/brands',
                breadcrumb: 'Бренды'
            }
        }
    },
    {
        path: '/brand/:id',
        name: 'brand-edit',
        component: () => import('@/pages/admin/BrandEdit.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Редактирование бренда',
            parent: {
                route: '/brands',
                breadcrumb: 'Бренды'
            }
        }
    },
    {
        path: '/stores/:brand?',
        name: 'stores',
        component: () => import('@/pages/admin/Stores.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Филиалы'
        }
    },
    {
        path: '/claim/:id/edit',
        name: 'claim-edit',
        component: () => import('@/pages/admin/ClaimEdit.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Редактировать заявку',
            parent: {
                route: '/claims',
                breadcrumb: 'Заявки'
            }
        }
    },
    {
        path: '/claims',
        name: 'claims',
        component: () => import('@/pages/admin/Claims.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Заявки'
        }
    },
    {
        path: '/access',
        name: 'access',
        component: () => import('@/pages/admin/Access.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Доступы приложений'
        }
    },
    {
        path: '/orders',
        name: 'orders',
        component: () => import('@/pages/admin/Orders.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Заказы'
        }
    },
    {
        path: '/store/create',
        name: 'store-create',
        component: () => import('@/pages/admin/StoreCreate.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Добавить филиал',
            parent: {
                route: '/stores',
                breadcrumb: 'Филиалы'
            }
        }
    },
    {
        path: '/store/:id',
        name: 'store-edit',
        component: () => import('@/pages/admin/StoreEdit.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Настройки филиала',
            parent: {
                route: '/stores',
              breadcrumb: 'Филиалы'
            }
        }
    },
    {
        path: '/store/edit/:id',
        name: 'store-edit-alt',
        component: () => import('@/pages/admin/StoreEditAlt.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Настройки филиала',
            parent: {
                route: '/stores',
                breadcrumb: 'Филиалы'
            }
        }
    },
    {
        path: '/terminals/:store?',
        name: 'terminals',
        component: () => import('@/pages/admin/Terminals.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Кассы'
        }
    },
    {
        path: '/menu/:store',
        name: 'menu',
        meta: {
            breadcrumb: 'Онлайн меню'
        },
        component: () => import('@/pages/Menu.vue')
    },
    {
        path: '/hall/:store?',
        name: 'hall',
        component: () => import('@/pages/Hall.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Залы'
        }
    },
    {
        path: '/table/:store?',
        name: 'table',
        component: () => import('@/pages/Table.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Столы'
        }
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('@/pages/ForgotPassword.vue'),
        meta: {
            layout: 'Default'
        }
    },
    {
        path: '/users',
        name: 'users',
        component: () => import('@/pages/admin/Users.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Пользователи'
        }
    },
    {
        path: '/users/trashed',
        name: 'users-trashed',
        component: () => import('@/pages/admin/UsersTrashed.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Архив пользователей'
        }
    },
    {
        path: '/payment-systems',
        name: 'payment-systems',
        component: () => import('@/pages/admin/PaymentSystems.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Платежные системы'
        }
    },
    {
        path: '/pos-types',
        name: 'pos-types',
        component: () => import('@/pages/admin/PosTypes.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Типы кассовых систем'
        }
    },
    {
        path: '/units',
        name: 'units',
        component: () => import('@/pages/admin/Units.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Единицы измерения'
        }
    },
    {
        path: '/references/cuisines',
        name: 'reference-cuisines',
        component: () => import('@/pages/admin/references/Cuisines.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Кухня и блюда'
        }
    },
    {
        path: '/references/classifications',
        name: 'reference-classifications',
        component: () => import('@/pages/admin/references/Classifications.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Типы заведений'
        }
    },
    {
        path: '/references/additionals',
        name: 'reference-additionals',
        component: () => import('@/pages/admin/references/Additionals.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Дополнительные'
        }
    },
    {
        path: '/card-info',
        name: 'card-info',
        component: () => import('@/pages/admin/CardInfo.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Данные банковских карт'
        }
    },
    {
        path: '/stickers',
        name: 'stickers',
        component: () => import('@/pages/admin/Stickers.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Стикеры'
        }
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: () => import('@/pages/admin/Notifications.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Рассылка'
        }
    },
    {
        path: '/payments',
        name: 'payments',
        component: () => import('@/pages/admin/Payments.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Платежи'
        }
    },
    {
        path: '/withdraw',
        name: 'withdraw',
        component: () => import('@/pages/admin/Withdraw.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Вывод чаевых'
        }
    },
    {
        path: '/income',
        name: 'income',
        component: () => import('@/pages/admin/Income.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Полученные чаевые'
        }
    },
    {
        path: '/reviews',
        name: 'reviews',
        component: () => import('@/pages/admin/Reviews.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Отзывы'
        }
    },
    {
        path: '/new',
        name: 'new',
        component: () => import('@/pages/QR.vue'),
        meta: {
            layout: 'Empty'
        }
    },
    {
        path: '/instructions',
        name: 'instructions',
        component: () => import('@/pages/Instructions.vue'),
        meta: {
            layout: 'Empty'
        }
    },
    {
        path: '/qr-generate/:token?',
        name: 'qr-generate',
        component: () => import('@/pages/admin/QrGenerate.vue'),
        meta: {
            layout: 'Empty'
        }
    },
    {
        path: '/payment-analytics',
        name: 'payment-analytics',
        component: () => import('@/pages/admin/PaymentAnalytics.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Отчет по платежам'
        }
    },
    {
        path: '/employee-roles',
        name: 'employee-roles',
        component: () => import('@/pages/admin/EmployeeRoles.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Роли сотрудников'
        }
    },
    {
        path: '/employees/:store?',
        name: 'employees',
        component: () => import('@/pages/admin/Employees.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Сотрудники'
        }
    },
    {
        path: '/employee/create',
        name: 'employee-create',
        component: () => import('@/pages/admin/EmployeeCreate.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Добавить сотрудника',
            parent: {
                route: '/employees',
                breadcrumb: 'Сотрудники'
            }
        }
    },
    {
        path: '/employee/:id',
        name: 'employee-edit',
        component: () => import('@/pages/admin/EmployeeEdit.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Настройки сотрудника',
            parent: {
                route: '/employees',
                breadcrumb: 'Сотрудники'
            }
        }
    },
    {
        path: '/employees/trashed',
        name: 'employees-trashed',
        component: () => import('@/pages/admin/EmployeesTrashed.vue'),
        meta: {
            layout: 'RahmatLayout',
            breadcrumb: 'Архив сотрудников',
            parent: {
                route: '/employees',
                breadcrumb: 'Сотрудники'
            }
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@/pages/Page404.vue'),
        meta: {
            layout: 'Empty'
        }
    }
]
export default routes
